<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'SETTINGS'" [breadcrumb]="''" icon="fa-cogs">
</app-breadcrumb>
<!-- body -->
<div (resized)="onResized($event)">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab *ngFor="let tab of tabs | keyvalue; let i = index;"
            title="{{tab.key | translate:patientLabel}}"
            [selected]="tabs?.size > selectedTab ? i === selectedTab : i === 0">
            <ng-template kendoTabContent>
                <kendo-tilelayout autoFlow="none" [columns]="columns" [gap]="30" [rowHeight]="175">
                    <div *ngFor="let item of tab.value; let i = index;">
                        <kendo-tilelayout-item (click)="navigate(item.route)" class="h-100">
                            <kendo-tilelayout-item-header>
                                <h5>
                                    <i style="color: black; opacity: .80;" class="fal {{item.icon}} pr-1"></i>
                                    {{ item.titleKey | translate:item.patientLabel}}
                                </h5>
                            </kendo-tilelayout-item-header>
                            <kendo-tilelayout-item-body class="montserrat custom-item-body">
                                {{item.descriptionKey | translate:item.patientLabel }}
                            </kendo-tilelayout-item-body>
                        </kendo-tilelayout-item>
                    </div>
                </kendo-tilelayout>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>